export class AzureRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonInternalResourceGroupName",
            "baseName": "eonInternalResourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementGroupId",
            "baseName": "managementGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "enableM365Restore",
            "baseName": "enableM365Restore",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enableEntraRestore",
            "baseName": "enableEntraRestore",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "optionalCapabilities",
            "baseName": "optionalCapabilities",
            "type": "AzureOptionalCapabilities",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
